import { http } from 'http';

export default {
  resendEmail: ({ idSecuencial, envioMail, estadoAprobacion }) =>
    http.post('/webh/operations/sendmail', {
      idSecuencial,
      envioMail,
      estadoAprobacion
    }),
  cancelOperation: ({ id }) => http.post(`/webh/operations/cancel/${id}`),
  notInterestedOperation: ({ id, cancelUser }) =>
    http.post('/webh/operations/notinterested', { id, cancelUser }),
  setToManualStudy: ({ operationId, operationGuid }) =>
    http.post('/webh/operations/settomanualstudy', { operationId, operationGuid }),
  sendSMS: ({ operationId }) => http.post(`webh/operations/SendCheckSMS/${operationId}`),
  resendSignature: ({ operationGuid, retailSessionTrace }) =>
    http.post(`operations/forwardToSignature/${operationGuid}`, { retailSessionTrace }),
  processRisk: ({ partnerId, campaignId, email, documentId, businessName }) =>
    http.post('/b2b/stepManager/prospect', {
      partnerId,
      campaignId,
      email,
      documentId,
      businessName
    }),
  cancelOperationActive: ({ guid, partnerId, campaignId, email, documentId, businessName }) =>
    http.post(`/b2b/stepManager/cancelOperacion/${guid}`, {
      partnerId,
      campaignId,
      email,
      documentId,
      businessName
    }),
  cancelOperationActiveB2C: (guid, params) =>
    http.post(`/operations/cancelAndCreateOperation/${guid}`, params)
};
